/*
 * Become A Dealer
 *
 * On Become A Dealer page, this scripts will handle hiding/showing
 * on certain condition.
 **/

//import 'parsleyjs';

// Other essential element class names
const formClassName = 'js-bad';

custom.becomeADealer = (() => {
  // Fields which prompt other field on condition
  const businessTypeClassName = 'js-bad-business-type';
  const businessTypeSecondaryClassName = 'js-bad-business-type-secondary';
  const countryClassName = 'js-bad-country';
  const provinceClassName = 'js-bad-province';
  const countrySelectClassName = 'js-country-select';
  const provinceSelecClassName = 'js-state-select';
  const contactSalesClassName = 'js-bad-contact-sales-rep';
  const roleClassName = 'js-bad-title-role';
  const sameAsOwnerAccountsPayable = 'js-bad-same-as-owner-accounts-payable';
  const sameAsOwnerCustomerService = 'js-bad-same-as-owner-customer-service';
  const productCategoryClassName = 'js-bad-product-category';

  // Contents class names (to toggle on condition)
  const retailerAdditionalClassName = 'js-bad-rugrack';
  const retailerAdditionalClassName2 = 'js-bad-number-stores';
  const retailerAdditionalClassName3 = 'js-bad-gift-retailer';
  const designerAdditionalClassName = 'js-bad-number-projects';
  const productTypeAdditionalClassName = 'js-bad-product-categories';
  const ecommerceAdditionalClassName = 'js-bad-certificate';
  const postalCodeClassName = 'js-bad-postal';
  const salesRepAdditionalClassName = 'js-bad-sales-rep-name';
  const sameAsOwnerAccountsPayableFieldsClassName =
    'js-bad-same-as-owner-accounts-payable-fields';
  const sameAsOwnerCustomerServiceFieldsClassName =
    'js-bad-same-as-owner-customer-service-fields';

  //Input IDS
  const certificateInput = '#BAD_certificate';
  const phoneInput = 'BAD_phone';
  const zipInput = 'BAD_zip';

  // Custom input for removing error from email field
  const customEmailInputClass = 'js-remove-form-error';

  /**
   * Disables a checkbox element and adds a class to its closest custom-checkbox parent.
   *
   * @param {Object} elem - The checkbox element to disable.
   * @param {string} classToToggle - The class to add to the closest custom-checkbox parent.
   */
  function disableCheckbox(elem, classToToggle) {
    elem
      .prop('checked', false)
      .prop('disabled', true)
      .prop('required', false)
      .closest('.custom-checkbox')
      .addClass(classToToggle);
  }
  /**
   * Enables a checkbox element and removes a class to its closest custom-checkbox parent.
   *
   * @param {Object} elem - The checkbox element to enable.
   * @param {string} classToToggle - The class to remove from the closest '.custom-checkbox' element.
   */
  function enableCheckbox(elem, classToToggle) {
    elem
      .prop('disabled', false)
      .prop('required', true)
      .closest('.custom-checkbox')
      .removeClass(classToToggle);
  }

  /**
   * Disable primary type selection in secondary type checkboxes.
   * Add roles depending on primary type
   *
   * @param {Object} event - The event object (optional)
   * @return {undefined}
   */
  function businessTypeHandler(event = null) {
    // are we on Become a Dealer form or not
    const eventTarget = event.target;
    const isBAD =
      $(eventTarget).closest('form').attr('id') == 'BecomeADealer'
        ? true
        : false;
    let businessType = $(eventTarget).val();
    // Disable primary type selection in secondary type checkboxes
    if (eventTarget.id === 'BAD_business-type' || $(eventTarget).hasClass(businessTypeClassName)) {
      //reset previously disabled secondary type checkboxes
      $(`.${businessTypeSecondaryClassName}`)
        .prop('disabled', false)
        .prop('required', true)
        .closest('.custom-checkbox')
        .removeClass('custom-checkbox--disabled');
      //disable match for secondary type
      $(`.${businessTypeSecondaryClassName}`)
        .filter((i, input) => input.value == businessType)
        .prop('checked', false)
        .prop('disabled', true)
        .prop('required', false)
        .closest('.custom-checkbox')
        .addClass('custom-checkbox--disabled');
    }   

    // Find all values selected for primary and secondary type
    // and show necessary fields.
    //wait for the DOM to update so that values don't appear twice and removed values are properly removed
    setTimeout(() => {
      let selected = new Array();
      $(`.${businessTypeSecondaryClassName}:checked`).each(function () {
        selected.push(this.value);
      });
      let primaryBusinessType = $(`.${businessTypeClassName}:checked`).val();
      if (primaryBusinessType) selected.push(primaryBusinessType);
      
      //show/hide business type specific questions
      businessTypeShowHide(selected, isBAD);
    }, 1);
  }

  /**
   * Show or hide specific fields based on the business types selected.
   *
   * @param {Array} businessTypes - An array of business types
   * @return {undefined} This function does not return a value
   */
  function businessTypeShowHide(businessTypes, isBAD) {
    //physical retail fields (rug rack, number of stores)
    if ($.inArray('Physical Retail', businessTypes) !== -1) {
      custom.utils.enableOption(`.${retailerAdditionalClassName}`);
      if (isBAD)
        custom.utils.enableOption(`.${retailerAdditionalClassName2}`);
      $(`.${retailerAdditionalClassName}`)
        .find('#rugRackNo')
        .prop('checked', true);
    } else {
      custom.utils.disableOption(`.${retailerAdditionalClassName}`);
      if (isBAD)
        custom.utils.disableOption(`.${retailerAdditionalClassName2}`);
      $(`.${retailerAdditionalClassName}`).find('input').prop('checked', false);
    }
    // Show gift retailer field if business type is physical or e-commerce retailer
    if ($.inArray('Physical Retail', businessTypes) !== -1 || $.inArray('E-commerce Retail', businessTypes) !== -1) {
      custom.utils.enableOption(`.${retailerAdditionalClassName3}`);
    } else {
      custom.utils.disableOption(`.${retailerAdditionalClassName3}`);
    }
    custom.utils.disableOption(`.${designerAdditionalClassName}`);
    if (isBAD) {
      //hide product categories question
      custom.utils.disableOption(`.${productTypeAdditionalClassName}`);
      if ($.inArray('Physical Retail', businessTypes) !== -1) {
        //show product categories question
        custom.utils.enableOption(`.${productTypeAdditionalClassName}`);
      }
      if ($.inArray('E-commerce Retail', businessTypes) !== -1) {
        //show product categories question
        custom.utils.enableOption(`.${productTypeAdditionalClassName}`);
      }
    }
  }

  /**
   * Show/hide certificate field depending on country selected.
   * Show/hide postal code field depending on country selected.
   * Modify phone validation depending on country selected.
   *
   * @param {Event|null} event - The event object (optional).
   * @return {undefined} This function does not return a value.
   */
  function countryProvinceWatcher(event = null) {
    const $target = $(event.currentTarget);
    $selectedOption = $target.find(':selected');
    if(!$selectedOption.length) return;
    //if no provinces, disable province, otherwise rebuild province select
    rebuildProvinceSelect($selectedOption.data('provinces'));
  }

  /**
   * Show/hide certificate field depending on country selected.
   * Show/hide postal code field depending on country selected.
   * Modify phone validation depending on country selected.
   *
   * @param {Event|null} event - The event object (optional).
   * @return {undefined} This function does not return a value.
   */
  function countryHandler(event = null) {
    const $target = $(event.currentTarget);
    const country = $target.val();
    //hide certificate field if outside US
    if (country == 'United States') {
      custom.utils.enableOption(`.${ecommerceAdditionalClassName}`);
    } else {
      custom.utils.disableOption(`.${ecommerceAdditionalClassName}`);
      $(certificateInput).val('').trigger('change');
    }

    //depending on country disable postal code field
    //https://tosbourn.com/list-of-countries-without-a-postcode/
    const noCodeCountries =
      "Angola,Antigua and Barbuda,Aruba,Ascension island,Bahamas,Belize,Benin,Botswana,Bolivia,Burkina Faso,Burundi,Cameroon,Central African Republic,Comoros,Congo,Cook Islands,Côte d'Ivoire,Curaçao,Djibouti,Dominica,East Timor,Equatorial Guinea,Eritrea,Fiji,French Southern Territories,Gambia,Gamon,Ghana,Grenada,Guyana,Heard and McDonald Islands,Hong Kong,Kiribati,Libya,Macau,Malawi,Mali,Mauritania,Nauru,Netherlands Antilles,Niue,North Korea,Qatar,Rwanda,Saint Kitts and Nevis,Sao Tome and Principe,Seychelles,Sierra Leone,Solomon Islands,Suriname,Syria,Timor-Leste,Togo,Tokelau,Tonga,Tuvalu,Uganda,United Arab Emirates,Vanuatu,Yemen,Zimbabwe";
    if (noCodeCountries.includes(country)) {
      //if in array, disable postal code field
      custom.utils.disableOption(`.${postalCodeClassName}`);
    } else {
      //else, enable it
      custom.utils.enableOption(`.${postalCodeClassName}`);
    }
    //update parsley phone and zip validation based on country
    const phone = $(`#${phoneInput}`);
    const phoneLabel = phone.siblings('.field__label');
    phone.removeAttr('data-parsley-pattern-message data-parsley-pattern');
    const zipCode = $(`#${zipInput}`);
    zipCode.removeAttr('data-parsley-valid-zip-postal data-parsley-length');
    switch (country) {
      case 'United States':
      case 'Canada':
        var label = 'Company Phone (###-###-####)';
        phone.attr({
          'data-parsley-pattern-message':
            'Please enter a valid company phone (###-###-####).',
          // prettier-ignore
          'data-parsley-pattern': '/^\\d{3}-\\d{3}-\\d{4}$/',
          placeholder: label,
        });
        phoneLabel.text(label);
        zipCode.attr({
          'data-parsley-valid-zip-postal': 'us,can',
          'data-parsley-length': '[5,7]',
          maxLength: 7,
        });
        break;
      default:
        var label = 'Company Phone (+###.########)';
        phone.attr({
          'data-parsley-pattern-message':
            'Please enter a valid company phone (+###.########).',
          // prettier-ignore
          'data-parsley-pattern': '/^\\+[0-9]{1,3}\\.[0-9]{7,14}$/',
          placeholder: label,
        });
        phoneLabel.text(label);
        zipCode.attr({ maxLength: 15 });
    }
    phone.parsley().reset();
  }

  /**
   * If no provinces, disable province, otherwise rebuild province select
   *
   * @param {Array[Array[string, string]]|null} provinces - Array of province values and labels
   * @return {void} No return value.
   */
  function rebuildProvinceSelect(provinces = []) {
    const $provinceSelect = $(`.${provinceSelecClassName}`);
    $provinceSelect.empty();
    if (provinces.length > 0) {
      custom.utils.enableOption(`.${provinceClassName}`);
      provinces.forEach((prov) => {
        $provinceSelect.append(
          `<option value="${prov[0]}">${prov[1]}</option>`,
        );
      });
    } else {
      custom.utils.disableOption(`.${provinceClassName}`);
    }
  }

  /**
   * If contact sales is selected, enable additional fields.
   *
   * @param {Event|null} event - The event object.
   * @return {void} No return value.
   */
  function contactSalesHandler(event = null) {
    const hasContact = $(event.target).val();

    // sales rep name field
    switch (hasContact) {
      case 'Yes':
        custom.utils.enableOption(`.${salesRepAdditionalClassName}`);
        break;
      default:
        custom.utils.disableOption(`.${salesRepAdditionalClassName}`);
    }
  }

  /**
   * Based on role(s) selected copy first, last, phone, email to subsequent sections.
   *
   * @param {Event} event - The event that triggered the role handling.
   * @return {void} This function does not return a value.
   */
  function roleHandler(event = null) {
    let selectedRoles = new Array();
    $(`.${roleClassName}:checked`).each(function () {
      selectedRoles.push(this.value);
    });

    const firstName = $('#BAD_first-name').val();
    const lastName = $('#BAD_last-name').val();
    const phone = $('#BAD_contact_phone').val();
    const email = $('#BAD_email').val();
    const firstNameOwner = $('#BAD_first-name-owner');
    const lastNameOwner = $('#BAD_last-name-owner');
    const phoneOwner = $('#BAD_phone-owner');
    const emailOwner = $('#BAD_email-owner');
    const firstNameAccountsPayable = $('#BAD_first-name-accounts-payable');
    const lastNameAccountsPayable = $('#BAD_last-name-accounts-payable');
    const phoneAccountsPayable = $('#BAD_phone-accounts-payable');
    const emailAccountsPayable = $('#BAD_email-accounts-payable');
    const firstNameCustomerService = $('#BAD_first-name-customer-service');
    const lastNameCustomerService = $('#BAD_last-name-customer-service');
    const phoneCustomerService = $('#BAD_phone-customer-service');
    const emailCustomerService = $('#BAD_email-customer-service');

    if ($.inArray('Owner/Sr. Management', selectedRoles) !== -1) {
      //fill in owner fields
      firstNameOwner.val(firstName);
      lastNameOwner.val(lastName);
      phoneOwner.val(phone);
      emailOwner.val(email);
    } else {
      //if they are still the same empty them out, this will toggle the fields
      if (firstNameOwner.val() === firstName) firstNameOwner.val('');
      if (lastNameOwner.val() === lastName) lastNameOwner.val('');
      if (phoneOwner.val() === phone) phoneOwner.val('');
      if (emailOwner.val() === email) emailOwner.val('');
    }
    if ($.inArray('Accounts Payable', selectedRoles) !== -1) {
      //fill in accounts payable fields
      firstNameAccountsPayable.val(firstName);
      lastNameAccountsPayable.val(lastName);
      phoneAccountsPayable.val(phone);
      emailAccountsPayable.val(email);
    } else {
      //if they are still the same empty them out, this will toggle the fields
      if (firstNameAccountsPayable.val() === firstName)
        firstNameAccountsPayable.val('');
      if (lastNameAccountsPayable.val() === lastName)
        lastNameAccountsPayable.val('');
      if (phoneAccountsPayable.val() === phone) phoneAccountsPayable.val('');
      if (emailAccountsPayable.val() === email) emailAccountsPayable.val('');
    }
    if ($.inArray('Customer Service', selectedRoles) !== -1) {
      //fill in customer service fields
      firstNameCustomerService.val(firstName);
      lastNameCustomerService.val(lastName);
      phoneCustomerService.val(phone);
      emailCustomerService.val(email);
    } else {
      //if they are still the same empty them out, this will toggle the fields
      if (firstNameCustomerService.val() === firstName)
        firstNameCustomerService.val('');
      if (lastNameCustomerService.val() === lastName)
        lastNameCustomerService.val('');
      if (phoneCustomerService.val() === phone) phoneCustomerService.val('');
      if (emailCustomerService.val() === email) emailCustomerService.val('');
    }
  }

  /**
   * Handles the event when the checkbox is clicked to determine if it is checked or not.
   *
   * @param {Object} event - The event object triggered by the checkbox click.
   * @return {undefined} - This function does not return a value.
   */
  function sameAsOwnerHandler(event) {
    if ($(event.target).is(':checked')) {
      //disable fields
      if (event.data.name === 'accounts-payable')
        custom.utils.disableOption(
          `.${sameAsOwnerAccountsPayableFieldsClassName}`,
        );
      if (event.data.name === 'customer-service')
        custom.utils.disableOption(
          `.${sameAsOwnerCustomerServiceFieldsClassName}`,
        );
      $(event.target)
        .closest('.field-row')
        .removeClass('mt-4')
        .addClass('mt-6');
    } else {
      //enable fields
      if (event.data.name === 'accounts-payable')
        custom.utils.enableOption(
          `.${sameAsOwnerAccountsPayableFieldsClassName}`,
          ['#BAD_phone-accounts-payable'],
        );
      if (event.data.name === 'customer-service')
        custom.utils.enableOption(
          `.${sameAsOwnerCustomerServiceFieldsClassName}`,
          ['#BAD_phone-customer-service'],
        );
      $(event.target)
        .closest('.field-row')
        .removeClass('mt-6')
        .addClass('mt-4');
    }
  }

  function noneSelectHandler(event) {
    let className = businessTypeSecondaryClassName;
    if ($(event.target).hasClass(productCategoryClassName))
      className = productCategoryClassName;

    if ($(event.target).is(':checked')) {
      //if none selected, disable all other fields
      $(`.${className}`)
        .filter((i, input) => input.value != 'None')
        .prop('checked', false)
        .prop('disabled', true)
        .prop('required', false)
        .closest('.custom-checkbox')
        .addClass('custom-checkbox--disabled');
    } else {
      //else, re-enable all other fields
      $(`.${className}`)
        .prop('disabled', false)
        .prop('required', true)
        .closest('.custom-checkbox')
        .removeClass('custom-checkbox--disabled');
    }
  }

  function getMultiCheckboxValues(input) {
    return $('#BecomeADealer')
      .find(input + ':checked')
      .map(function () {
        return this.value;
      })
      .get()
      .join(';');
  }

  function getSelectValue(input) {
    const selectVal = $('#BecomeADealer')
      .find(input + ' option:selected')
      .val();
    return selectVal != 'Select An Option' ? selectVal : '';
  }

  function getRadioValue(input) {
    const selectVal = $('#BecomeADealer')
      .find(input + ':checked')
      .val();
    return selectVal ? selectVal : '';
  }

  /**
   * Handles the submission of a form.
   *
   * @param {Object} form - The form to be submitted.
   * @return {undefined} This function does not return a value.
   */
  function formSubmissionHandler(form = null) {
    // Find the submit button inside the form
    const $submitButton = $(form).find('button[type="submit"]');

    // Show a loading animation on the submit button
    custom.utils.submitLoaderHandler($submitButton);

    // Show loading disclaimer message
    $('#ota-submit-progress').removeClass('hidden');

    // Find the form with id "BecomeADealer"
    const BADform = $('#BecomeADealer');

    // Create a new instance of FormData with the BADform
    const hutk = custom.utils.getCookie('hubspotutk');
    const postForm = $submitButton.data('form');
    const sendData = {
      submittedAt: new Date().getTime(),
      fields: [
        {
          objectTypeId: '0-2', //company
          name: 'name',
          value: BADform.find('input[name="Company"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'website',
          value: BADform.find('input[name="Website"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'social_media_link',
          value: BADform.find('input[name="Social Media Link"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'address',
          value: BADform.find('input[name="Address"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'address2',
          value: BADform.find('input[name="Address 2"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'city',
          value: BADform.find('input[name="City"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'country',
          value: getSelectValue('select[name="Country"]'),
        },
        {
          objectTypeId: '0-2', //company
          name: 'state',
          value: getSelectValue('select[name="State/Province"]'),
        },
        {
          objectTypeId: '0-2', //company
          name: 'zip',
          value: BADform.find('input[name="Zip"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'phone',
          value: BADform.find('input[name="Company Phone"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'primary_type_of_business',
          value: getRadioValue('.js-bad-business-type'), 
        },
        {
          objectTypeId: '0-2', //company
          name: 'how_many_stores_does_your_company_currently_operate_',
          value: getSelectValue(
            'select[name="How many stores does your company currently operate?"]',
          ),
        },
        {
          objectTypeId: '0-2', //company
          name: 'rug_rack',
          value:
            BADform.find('input[name="Rug Rack"]:checked').val() != undefined
              ? BADform.find('input[name="Rug Rack"]:checked').val()
              : '',
        },
        {
          objectTypeId: '0-2', //company
          name: 'gift_retailer',
          value:
            BADform.find('input[name="gift_retailer"]:checked').val() != undefined
              ? BADform.find('input[name="gift_retailer"]:checked').val()
              : '',
        },
        {
          objectTypeId: '0-2', //company
          name: 'what_product_categories_does_your_business_purchase_',
          value: getMultiCheckboxValues(
            'input[name="What product categories does your business purchase?[]"]',
          ),
        },
        {
          objectTypeId: '0-2', //company
          name: 'secondary_type_of_business',
          value: getMultiCheckboxValues(
            'input[name="Secondary Type Of Business[]"]',
          ),
        },
        {
          objectTypeId: '0-2', //company
          name: 'what_is_your_company_s_annual_revenue_',
          value: getSelectValue(
            'select[name="What is your companys annual revenue?"]',
          ),
        },
        {
          objectTypeId: '0-2', //company
          name: 'tax_id_or_ein',
          value: BADform.find('input[name="Tax ID or EIN"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'resale_certificate',
          value: BADform.find('input[name="File Url"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'sales_rep_in_contact',
          value: BADform.find(
            'input[name="In contact with a Sales Rep"]:checked',
          ).val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'sales_rep_name',
          value: BADform.find('input[name="Sales Rep Name"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'how_did_you_hear',
          value: getMultiCheckboxValues('input[name="How did you hear?[]"]'),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'how_did_you_hear_about_us_other',
          value: BADform.find('input[name="Other"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'firstname',
          value: BADform.find('input[name="First Name"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'lastname',
          value: BADform.find('input[name="Last Name"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'email',
          value: BADform.find('input[name="email"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'phone',
          value: BADform.find('input[name="Contact Phone"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'role',
          value: getMultiCheckboxValues('input[name="Role[]"]'),
        },
        {
          objectTypeId: '0-2', //company
          name: 'owner_first_name',
          value: BADform.find('input[name="Owner First Name"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'owner_last_name',
          value: BADform.find('input[name="Owner Last Name"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'owner_email',
          value: BADform.find('input[name="Owner Email"]').val(),
        },
        {
          objectTypeId: '0-2', //company
          name: 'owner_phone',
          value: BADform.find('input[name="Owner Phone"]').val(),
        },
        {
          objectTypeId: '0-1', //contact
          name: 'accept_terms_and_conditions__trade_form_',
          value: BADform.find('input[name="Accept Terms and Conditions"]').is(
            ':checked',
          )
            ? 'Yes'
            : 'No',
        },
        {
          objectTypeId: '0-1', //contact
          name: 'newsletter',
          value: BADform.find('input[name="Email Signup"]').is(':checked')
            ? 'Yes'
            : 'No',
        },
        {
          objectTypeId: '0-1', //contact
          name: 'sms_opt_in',
          value: BADform.find('input[name="SMS Signup"]').is(':checked')
            ? 'Yes'
            : 'No',
        },
        {
          objectTypeId: '0-1', //contact
          name: 'trade_project_needs__trade_form_',
          value:
            BADform.find(
              'input[name="Which best describes your needs that Loloi could help fulfill?"]:checked',
            ).val() != undefined
              ? BADform.find(
                  'input[name="Which best describes your needs that Loloi could help fulfill?"]:checked',
                ).val()
              : '',
        },
      ],
      context: {
        ...(hutk ? { hutk: hutk } : {}),
        pageUri: window.location.host + window.location.pathname,
        pageName: document.title,
      },
    };

    //console.log(sendData);
    window.MUAPP.sendCRMForm(postForm, sendData).then(
      (data) => {
        // If the request is successful, redirect to the thank-you page
        if ($(form).data('category')) custom.gtmDatalayer.gtmPushElem($(form));
        window.location.href = '/account/register?view=thank-you';
      },
      (err) => {
        // If the request fails, remove the loading animation from the submit button
        custom.utils.removeSubmitLoaderHandler($submitButton);

        // hide loading disclaimer message
        $('#ota-submit-progress').addClass('hidden');

        // Show an error message in the form
        $(form)
          .find(`.${formClassName}-error`)
          .removeClass('hidden')
          .text('Error, please try again.');
      },
    );
  }

  /**
   * returnFileUploadHandler
   * @function
   *
   * @param {string} id - SPARS(Shopify) order ID
   *
   * Injects SPARS order ID in DOM
   * NOTE: Refactor possible, could move to utils?
   */
  const badFileUploadHandler = () => {
    $('.js-file-input').change(function () {
      const inputTarget = $(this).data('targetid');
      const $fileName = $(this)
        .closest(`.custom-file-upload__dropzone`)
        .find('.custom-file-upload__name');
      const fileName = $(this)[0].files[0].name;

      $fileName.text('Uploading...');

      var form = new FormData();
      form.append('certificate', $(this)[0].files[0]);

      window.MUAPP.uploadFile(
        form,
        (data) => {
          $fileName.text(fileName);
          $(`#${inputTarget}`).val($.parseJSON(data).file_url);
        },
        (data) => {
          $fileName.text('Error occured.');
        },
      );
    });
  };

  function triggerSubmission() {
    // triggered by gcaptcha
    formSubmissionHandler($(`.${formClassName}`));
  }

  /**
   * Clears the error state of an email input field and removes the error message.
   *
   * @param {Event} event - The event object that triggered the function.
   * @return {void} This function does not return a value.
   */
  function clearError(event) {
    if (
      $(event.currentTarget)
        .closest(`.${customEmailInputClass}`)
        .hasClass('parsley-error')
    ) {
      $(event.currentTarget)
        .closest(`.${customEmailInputClass}`)
        .removeClass('parsley-error')
        .find('.error-email')
        .empty();
    }
  }

  /**
   * Initializes event listeners for the form.
   *
   * @returns {void}
   */
  function init() {
    // Check if there are any elements to initialize
    if (!$(`.${businessTypeClassName}`).length > 0) return;

    // are we on Become a Dealer form or not
    const isBAD =
      $(`.${businessTypeClassName}`).closest('form').attr('id') ==
      'BecomeADealer'
        ? true
        : false;


    $(`.${businessTypeClassName}, .${businessTypeSecondaryClassName}`).on(
      'change',
      businessTypeHandler,
    );

    // Initialize event listener for "none" selections
    $('#secondary_none').on('change', noneSelectHandler);

    // Initialize event listeners for country selection to update province select
    $(`.${countrySelectClassName}`).on('load', countryProvinceWatcher);
    $(`.${countrySelectClassName}`).on('change', countryProvinceWatcher);


    // Open trade account form specific init
    if (isBAD) {
      // Initialize event listeners for country selection
      $(`.${countryClassName}`).on('load', countryHandler);
      $(`.${countryClassName}`).on('change', countryHandler);

      // Initialize event listeners for contact sales and role
      $(`.${contactSalesClassName}`).on('change', contactSalesHandler);
      $(`.${roleClassName}`).on('change', roleHandler);

      // Initialize event listener for "none" selections
      $('#product_category_none').on('change', noneSelectHandler);

      // Initialize event listener for clearing email error
      if ($('#BAD_email').length > 0) $(`#BAD_email`).on('keydown', clearError);

      // Trigger country load if it is United States
      if ($(`.${countryClassName}`).val() === 'United States') {
        $(`.${countryClassName}`).trigger('load');
      }

      //phone validation and input mask
      var element = document.getElementById(phoneInput);
      var maskOptions = {
        mask: '000-000-0000',
      };
      //var mask = IMask(element, maskOptions);
      //https://imask.js.org/guide.html#masked-dynamic
      //https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers#Central_America
      //South American numbers are too complex for single masks
      //https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s03.html - intl #'s
      //https://regex101.com/r/wZ4uU6/1 - universal regex
      var dispatchMask = IMask(element, {
        mask: [
          { ...maskOptions, country: 'United States' },
          { ...maskOptions, country: 'Canada' },
          {
            // prettier-ignore
            mask: '+0[00].0000000[0000000]',
          },
        ],
        dispatch: function (appended, dynamicMasked) {
          const country = document.getElementById('AddressCountry_BAD').value;
          const defaultMask =
            dynamicMasked.compiledMasks[dynamicMasked.compiledMasks.length - 1];
          //find mask that matches country selection
          let maskMatch = dynamicMasked.compiledMasks.find(function (m) {
            return country === m.country;
          });
          //if no match, use default
          if (maskMatch !== undefined) {
            return maskMatch;
          } else {
            return defaultMask;
          }
        },
      });
      //initialize file upload handler
      if ($('.js-file-input').length > 0) {
          badFileUploadHandler();
      }
    }
  }

  return {
    init,
    triggerSubmission,
    formSubmissionHandler,
  };
})();

// create global variable for invisible captcha to callback
window.triggerSubmission = custom.becomeADealer.triggerSubmission;



// WEBPACK FOOTER //
// ./src/scripts/src/custom/become-a-dealer.js